import { asyncTimeOut, clone, requiredParam } from '@/service/util'
import * as pedido from '@/api/pedido'
import * as featureToggle from '@/api/feature_toggle'
import * as consulta from '@/api/consultas'
import store from '@/store'

function montaAtendimentoCtrl () {
  return {
    modalPossibilidades: false,
    modalAgendar: false,
    edicaoEntidade: false,
    confirmaEntidade: false,
    agendaAutomatico: false,
    imprimeContratos: false,
    imprimeRelacao: false,
    finaliza: false,
    descarta: false,
    atendimento: {
      open: false,
      tipo: ''
    },
    negocio: {
      open: false,
      component: '',
      produto: {},
      item: {},
      outros: []
    },
    storagedRota: false,
    modalCliente: 0,
    lancaContratos: false,
    emAtendimentoTele: false,
    modalAtendimentoTele: false,
    venda_digital: false,
    data_validacao: null
  }
}

function montaEmAtendimento () {
  return {
    possibilidadeAgendar: {}
  }
}

function tipoItem (identificacao) {
  let tipo = 'padrao'
  switch (identificacao) {
    case 'consignado_inss':
      tipo = 'inss'
      break
  }
  return tipo
}

const state = {
  precisaSalvar: false,
  emAtendimento: montaEmAtendimento(),
  atendimentoCtrl: montaAtendimentoCtrl(),
  histAtendimentos: [],
  fimAtendimentos: false,
  validado: false,
  statusChamadaAPI: false,
  pedidoRecalculando: false,
  triggerGetPedidos: false,
  triggerGetMotivos: false,
  motivos: [],
  naoAtrativo: false,
  recalculando: false,
  exibeResumo: true,
  jaCalculado: false,
  siape: false,
  cadastral: false,
  statusBloqueiaAcoes: false
}

const getters = {
  pedidoAtendimento: state => {
    if (state.emAtendimento.id) {
      return state.emAtendimento
    }
    return {}
  },
  entidadeAtendimento: state => {
    if (state.emAtendimento.entidade) return state.emAtendimento.entidade
    return {}
  },
  leedAtendimento: state => {
    if (state.emAtendimento.leed) return state.emAtendimento.leed
    return {}
  },
  agendamentoAtendimento: state => {
    if (state.emAtendimento.agendamento) return state.emAtendimento.agendamento
    return {}
  },
  historicoAtendimento: state => {
    if (state.emAtendimento.historico) {
      const result = []
      let historicos = state.emAtendimento.historico
      for (let hs = 0; hs < historicos.length; hs++) {
        let historico = historicos[hs]
        for (let h = 0; h < historico.historicos.length; h++) {
          let item = historico.historicos[h]
          if ((h + 1) === historico.historicos.length) item.novo = true
          else item.novo = false
          result.push(item)
        }
        if (historicos[hs + 1]) {
          if (hs === 0) result.push({atual: true})
          else result.push({outro: true})
        }
      }
      return result
    }
    return []
  },
  itensAtendimento: state => {
    if (!state.emAtendimento.id) return []
    return state.emAtendimento.itens
  },
  countItensAtendimento: state => {
    if (!state.emAtendimento.id) return []
    return Object.keys(state.emAtendimento.itens).length
  },
  atendimentoIdade: state => {
    if (state.emAtendimento.entidade && state.emAtendimento.entidade.data_nascimento) {
      let dtAtual = new Date()
      let dtNasc = new Date(state.emAtendimento.entidade.data_nascimento)
      let anoAtual = dtAtual.getFullYear()
      let niver = new Date(anoAtual, dtNasc.getMonth(), dtNasc.getDate())
      let age = anoAtual - dtNasc.getFullYear()
      if (niver > dtAtual) {
        age = age - 1
      }
      return age
    }
    return 0
  },
  atendimentoIsLeed: state => {
    if (state.emAtendimento.entidade) {
      if (state.emAtendimento.entidade.id) return false
    }
    return true
  },
  allItensAtendimento: state => {
    let registros = []
    if (state.emAtendimento.itens) {
      Object.keys(state.emAtendimento.itens).forEach(i => {
        registros.push(...state.emAtendimento.itens[i].itens)
      })
    }
    return registros
  },
  pedidoEmFechamento: (state, getters) => getters.agendamentoAtendimento.classificacao === 'fechamento',
  fisica: state => {
    return state.emAtendimento.entidade && state.emAtendimento.entidade.registro.length === 11
  }
}

const mutations = {
  MODALPOSSIBILIDADES (state) {
    state.atendimentoCtrl.modalPossibilidades = !state.atendimentoCtrl.modalPossibilidades
  },
  MODALAGENDAR (state, item) {
    state.atendimentoCtrl.modalAgendar = !state.atendimentoCtrl.modalAgendar
    state.emAtendimento.possibilidadeAgendar = item
  },
  CLEANATENDIMENTOCONTROL (state) {
    state.atendimentoCtrl = montaAtendimentoCtrl()
  },
  CLEANATENDIMENTO (state) {
    state.emAtendimento = montaEmAtendimento()
  },
  SETATENDIMENTO (state, payload) {
    state.emAtendimento = Object.assign({}, montaEmAtendimento(), payload)
  },
  SETHISTORICO (state, payload) {
    state.emAtendimento.historico = payload
  },
  SETENTIDADE (state, payload) {
    state.emAtendimento.entidade.nome = payload.nome
    state.emAtendimento.entidade.data_nascimento = payload.data_nascimento
  },
  SETEMAILS (state, payload) {
    state.emAtendimento.entidade.emails = payload
  },
  SETTELEFONES (state, payload) {
    state.emAtendimento.entidade.telefones = payload
  },
  SETENDERECOS (state, payload) {
    state.emAtendimento.entidade.enderecos = payload
  },
  SETVEICULOS (state, payload) {
    state.emAtendimento.entidade.veiculos = payload
  },
  SETEMPREGOS (state, payload) {
    state.emAtendimento.entidade.empregos = payload
  },
  SETEMPRESAS (state, payload) {
    state.emAtendimento.entidade.empresas = payload
  },
  SETSOCIOS (state, payload) {
    state.emAtendimento.entidade.socios = payload
  },
  CLOSEENTIDADE (state) {
    state.atendimentoCtrl.edicaoEntidade = false
  },
  EDITAENTIDADE (state, payload) {
    state.atendimentoCtrl.edicaoEntidade = !state.atendimentoCtrl.edicaoEntidade
  },
  EDITAENTIDADEFORCADO (state) {
    state.atendimentoCtrl.edicaoEntidade = true
  },
  CONFIRMARENTIDADE (state, payload) {
    state.atendimentoCtrl.confirmaEntidade = !state.atendimentoCtrl.confirmaEntidade
  },
  OPENFINALIZA (state, payload) {
    state.atendimentoCtrl.finaliza = payload
  },
  OPENDESCARTA (state, payload) {
    state.atendimentoCtrl.descarta = payload
  },
  OPENATENDIMENTO (state, payload) {
    state.atendimentoCtrl.atendimento.open = true
    state.atendimentoCtrl.atendimento.tipo = payload
  },
  CLOSEATENDIMENTO (state) {
    state.atendimentoCtrl.atendimento.open = false
    state.atendimentoCtrl.atendimento.tipo = ''
    return true
  },
  OPENNEGOCIO (state, { tipo, produto, item, outros }) {
    if (tipo !== '') {
      state.atendimentoCtrl.negocio.open = true
      state.atendimentoCtrl.negocio.tipo = tipo
      state.atendimentoCtrl.negocio.produto = produto
      state.atendimentoCtrl.negocio.item = item
      state.atendimentoCtrl.negocio.outros = outros
    }
  },
  CLOSENEGOCIO (state) {
    state.atendimentoCtrl.negocio.open = false
    state.atendimentoCtrl.negocio.tipo = ''
    state.atendimentoCtrl.negocio.produto = {}
    state.atendimentoCtrl.negocio.item = {}
    state.atendimentoCtrl.negocio.outros = {}
    return true
  },
  SETITENS (state, payload) {
    state.emAtendimento.itens = payload
  },
  GETFUTUROS (state, payload) {
    state.futuros = payload
  },
  MOSTRAAGENDAAUTOMATICO (state, payload) {
    state.atendimentoCtrl.agendaAutomatico = payload
  },
  MOSTRAIMPRIMECONTRATOS (state, payload) {
    state.atendimentoCtrl.imprimeContratos = payload
  },
  MOSTRAIMPRIMERELACAO (state, payload) {
    state.atendimentoCtrl.imprimeRelacao = payload
  },
  MOSTRALANCARCONTRATOS (state, payload) {
    state.atendimentoCtrl.lancaContratos = payload
  },
  SETHISTATENDIMENTOS (state, payload) {
    state.histAtendimentos = payload
  },
  SETHISTATENDIMENTOSPUSH (state, payload) {
    if (payload.length) state.histAtendimentos = state.histAtendimentos.concat(payload)
    else state.fimAtendimentos = true
  },
  STORAGEROTA (state, payload) {
    state.atendimentoCtrl.storagedRota = payload
  },
  CONTROLAMODALCLIENTE (state, payload) {
    state.atendimentoCtrl.modalCliente = payload
  },
  SETATENDIMENTOTELE (state, payload) {
    state.atendimentoCtrl.emAtendimentoTele = payload
  },
  MOSTRAMODALATENDIMENTOTELE (state, payload) {
    state.atendimentoCtrl.modalAtendimentoTele = payload
  },
  MUDAVENDADIGITAL (state, payload) {
    state.emAtendimento.venda_digital = payload
  },
  VALIDAPROPOSTA (state, payload) {
    state.emAtendimento.data_validacao = payload.data_validacao
  },
  SETDATACALCULO (state, payload) {
    state.emAtendimento.data_calculado = payload
  },
  SETVALIDADATAVALIDACAO (state, payload) {
    state.validado = payload
  },
  SALVAANTESVALIDAR (state, payload) {
    state.precisaSalvar = payload
  },
  CTRLDESVALIDARPROPOSTA (state, payload) {
    state.ctrlDesvalidarProposta = payload
  },
  STATUSCHAMADAAPI (state, payload) {
    state.statusChamadaAPI = payload
  },
  SETPEDIDORECALCULANDO (state, payload) {
    state.pedidoRecalculando = payload
  },
  SETTRIGGERGETPEDIDOS (state) {
    state.triggerGetPedidos = !state.triggerGetPedidos
  },
  SETTRIGGERGETMOTIVOS (state) {
    state.triggerGetMotivos = !state.triggerGetMotivos
  },
  SETMOTIVOS (state, payload) {
    state.motivos = payload
  },
  CORRIGERESUMO (state, payload) {
    state.emAtendimento.itens.consignado_inss = payload
  },
  NAOATRATIVO (state, payload) {
    state.naoAtrativo = payload
  },
  SETRECALCULANDO (state, payload) {
    state.recalculando = payload
  },
  TOGGLERESUMO (state, payload) {
    state.exibeResumo = payload
  },
  FOICALCULADO (state, payload) {
    state.jaCalculado = payload
  },
  SETATENDIMENTOENTIDADEHIGIENIZADA (state, payload) {
    state.emAtendimento.entidade.telefones = payload.telefones
  },
  SETSIAPE (state, payload) {
    state.siape = payload
  },
  SETCADASTRAL (state, payload) {
    state.cadastral = payload
  },
  SETFGTS (state, payload) {
    state.fgts = payload
  },
  CONTROLABLOQUEIAACOES (state, payload) {
    state.statusBloqueiaAcoes = payload
  },
  SETDATARELACIONADOS (state, payload) {
    if (state.emAtendimento.entidade) state.emAtendimento.entidade.consulta_relacionados = true
  },
  ATUALIZANOMEFGTS (state, payload) {
    if (state.emAtendimento.entidade) state.emAtendimento.entidade.nome = payload
  }
}

const actions = {
  modalPossibilidades ({commit}) {
    commit('MODALPOSSIBILIDADES')
  },
  modalAgendar ({commit}, item) {
    commit('MODALPOSSIBILIDADES')
    commit('MODALAGENDAR', item)
  },
  async buscaMotivos ({ commit }, id) {
    let motivos = await pedido.motivos(id)
    commit('SETMOTIVOS', motivos)
  },
  async buscaMotivosLocalizado ({ commit }, id) {
    let motivos = await pedido.motivos(id)
    return motivos
  },
  async buscaMotivosItem ({ commit }, itemId) {
    let motivos = await pedido.motivosItens(state.emAtendimento.id, itemId)
    return motivos
  },
  async buscaPedidos (context, q) {
    await asyncTimeOut('buscaPedidos')

    let endpoint = null
    let data
    try {
      endpoint = await featureToggle.buscarEndpoint({ name: 'search-pedido' })
      endpoint = endpoint.instancia
    } catch (error) {
      console.error('Erro feature toggle Busca de Pedido', error.message)
    }

    if (endpoint === 'csharp') {
      data = await pedido.searchNovo(q)
      data = data.instancia
    } else data = pedido.search(q)

    return data
  },
  async cleanAtendimento ({ commit, dispatch }) {
    await dispatch('pedidoInss/cleanBeneficios', {}, { root: true })
    commit('CLEANATENDIMENTO')
    commit('CLEANATENDIMENTOCONTROL')
  },
  async getPedido ({ commit, dispatch }, id) {
    store.dispatch('relacionados/limpaRelacionados')
    commit('CLEANATENDIMENTOCONTROL')
    await dispatch('pedidoInss/cleanBeneficios', {}, { root: true })
    let data = await pedido.get(id)
    commit('SETATENDIMENTO', data)

    return []
  },
  async novoPedido ({ commit, dispatch }, payload) {
    commit('CLEANATENDIMENTOCONTROL')
    await dispatch('pedidoInss/cleanBeneficios', {}, { root: true })
    payload.produto = { id: 1 }

    let data

    if (payload.cpf) {
      let endpoint = null
      try {
        endpoint = await featureToggle.buscarEndpoint({ name: 'pedido-novo' })
        endpoint = endpoint.instancia
      } catch (error) {
        console.error('Erro feature toggle Pedido novo', error.message)
      }

      if (endpoint === 'csharp') {
        data = await pedido.novoCsharp(payload)
        data = data.instancia
      } else data = await pedido.novo(payload)
    } else if (payload.cnpj) {
      data = await pedido.novoCNPJ(payload)
    } else if (payload.telefone) {
      data = await pedido.novoTelefone(payload)
    }

    commit('SETATENDIMENTO', data)
    return data
  },
  async editaEntidade ({ commit, dispatch }) {
    dispatch('closeNegocio')
    commit('CLOSEATENDIMENTO')
    commit('EDITAENTIDADE')
  },
  async editaEntidadeForcado ({ commit, dispatch }) {
    dispatch('closeNegocio')
    commit('CLOSEATENDIMENTO')
    commit('EDITAENTIDADEFORCADO')
  },
  async confimarEntidade ({ commit, dispatch }) {
    commit('CONFIRMARENTIDADE')
  },
  async salvarLeed ({ commit }, cpf) {
    commit('SETATENDIMENTO', await pedido.salvarLeed(state.emAtendimento.id, { cpf }))
  },
  async salvaEntidade ({ state, commit }, dados) {
    let reg = await pedido.editaEntidade(state.emAtendimento.id, dados)
    commit('SETENTIDADE', reg)
    return reg
  },
  async salvaEmails ({ state, commit }, dados) {
    let reg = await pedido.editaEmails(state.emAtendimento.id, dados)
    commit('SETEMAILS', reg)
  },
  async salvaTelefones ({ state, commit }, dados) {
    let reg = await pedido.editaTelefones(state.emAtendimento.id, dados)
    commit('SETTELEFONES', reg)
  },
  async salvaTelefonesSR ({ state, commit }, dados) { // nao retorna os dados para o store
    await pedido.editaTelefones(state.emAtendimento.id, dados)
  },
  async salvaEnderecos ({ state, commit }, dados) {
    let reg = await pedido.editaEnderecos(state.emAtendimento.id, dados)
    commit('SETENDERECOS', reg)
    return reg
  },
  async salvaVeiculos ({ state, commit }, dados) {
    let reg = await pedido.editaVeiculos(state.emAtendimento.id, dados)
    commit('SETVEICULOS', reg)
  },
  async salvaEmpregos ({ state, commit }, dados) {
    let reg = await pedido.editaEmpregos(state.emAtendimento.id, dados)
    commit('SETEMPREGOS', reg)
  },
  async salvaEmpresas ({ state, commit }, dados) {
    let reg = await pedido.editaEmpresas(state.emAtendimento.id, dados)
    commit('SETEMPRESAS', reg)
  },
  async salvaSocios ({ state, commit }, dados) {
    let reg = await pedido.editaSocios(state.emAtendimento.id, dados)
    commit('SETSOCIOS', reg)
  },
  openFinaliza ({ commit, dispatch }) {
    dispatch('closeNegocio')
    commit('CLOSEENTIDADE')
    commit('CLOSEATENDIMENTO')
    return commit('OPENFINALIZA', true)
  },
  openDescarta ({ commit, dispatch }) {
    dispatch('closeNegocio')
    commit('CLOSEENTIDADE')
    commit('CLOSEATENDIMENTO')
    return commit('OPENDESCARTA', true)
  },
  closeFinaliza ({ commit }) {
    return commit('OPENFINALIZA', false)
  },
  closeDescarta ({ commit }) {
    return commit('OPENDESCARTA', false)
  },
  async openAtendimento ({ commit, state, dispatch }, tipo) {
    if (state.atendimentoCtrl.atendimento.open && state.atendimentoCtrl.atendimento.tipo === tipo) {
      return commit('CLOSEATENDIMENTO')
    } else {
      dispatch('closeNegocio')
      commit('CLOSEENTIDADE')
      return commit('OPENATENDIMENTO', tipo)
    }
  },
  async agendarAtendimento ({ state }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    return pedido.agendar(state.emAtendimento.id, dados)
  },
  async agendarAtendimentoRapido ({ state }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    return pedido.agendarRapido(state.emAtendimento.id, dados)
  },
  async salvarConsulta ({ state }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    return pedido.salvar(state.emAtendimento.id, dados)
  },
  async setHistorico ({ commit }, data) {
    commit('CLEANATENDIMENTOCONTROL')
    commit('SETHISTORICO', data)
    return data
  },
  async emailAtendimento ({ state, dispatch }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    let data = await pedido.historicoEmail(state.emAtendimento.id, JSON.parse(dados))
    return dispatch('setHistorico', data)
  },
  async whatsAtendimento ({ state, dispatch }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    let data = await pedido.historicoWhats(state.emAtendimento.id, dados)
    return dispatch('setHistorico', data)
  },
  async smsAtendimento ({ state, dispatch }, dados) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    let data = await pedido.historicoSMS(state.emAtendimento.id, dados)
    return dispatch('setHistorico', data)
  },
  async openNegocio ({ state, dispatch, commit }, identificacao) {
    await dispatch('closeNegocio')
    await commit('CLOSEATENDIMENTO')
    commit('CLOSEENTIDADE')
    if (identificacao && identificacao.startsWith('cadastral_')) {
      const tipo = identificacao.replace('cadastral_', '')
      await dispatch('pedidoCadastral/selecionaTipo', tipo, { root: true })
      await commit('OPENNEGOCIO', {
        tipo: 'cadastral',
        produto: { identificacao, nome: 'Consulta cadastral' },
        item: { identificacao, nome: 'Consulta cadastral' }
      })
    } else if (identificacao !== 'consignado_siape' && identificacao !== 'consignado_fgts') {
      let tipo = tipoItem(identificacao)
      let produto = await dispatch('informacoes/getIdentProduto', identificacao, { root: true })
      // Busca item
      let item = {}
      let outros = {}
      if (state.emAtendimento.itens) {
        Object.keys(state.emAtendimento.itens).forEach(i => {
          if (i === produto.identificacao) item = clone(state.emAtendimento.itens[i])
          else if (i !== 'consignado_siape') outros[i] = clone(state.emAtendimento.itens[i])
        })
      }
      await commit('OPENNEGOCIO', { tipo, produto, item, outros })
    } else if (identificacao === 'consignado_fgts') {
      await commit('OPENNEGOCIO', { tipo: 'fgts', produto: { identificacao: 'consignado_fgts', nome: 'Consignado FGTS' }, item: { identificacao: 'consiconsignado_fgtsgnado_siape', nome: 'Consignado FGTS' } })
    } else {
      await commit('OPENNEGOCIO', { tipo: 'siape', produto: { identificacao: 'consignado_siape', nome: 'Consignado SIAPE' }, item: { identificacao: 'consignado_siape', nome: 'Consignado SIAPE' } })
    }
  },
  async closeNegocio ({ commit }) {
    return commit('CLOSENEGOCIO')
  },
  async salvaItens ({ state, commit }, itens) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    itens = await pedido.editaItens(state.emAtendimento.id, {itens})
    let itensSalvos = await pedido.getItens(state.emAtendimento.id)
    commit('SETITENS', itensSalvos)
    return itens
  },
  async salvaItensINSS ({ state, commit }, itens) {
    if (!state.emAtendimento.id) throw new Error('Nenhum atendimento encontrado!')
    itens = await pedido.editaItensINSS(state.emAtendimento.id, itens)
    commit('SETITENS', await pedido.getItens(state.emAtendimento.id))
    return itens
  },
  async tlmkPedido ({ commit, dispatch }, id) {
    commit('CLEANATENDIMENTOCONTROL')
    const data = await pedido.listagemPedido(id)
    commit('SETATENDIMENTO', data)
    await dispatch('openNegocio', 'consignado_inss')
    return data
  },
  async atualizaResumo ({ state, commit }) {
    commit('SETITENS', await pedido.getItens(state.emAtendimento.id))
    commit('NAOATRATIVO', false)
  },
  async atualizaDataCalculo ({ state, commit }) {
    const retorno = await pedido.dataCalculado(state.emAtendimento.id)
    commit('SETDATACALCULO', retorno)
  },
  async atualizaResumoReabre ({ state, commit }) {
    commit('SETITENS', await pedido.getItensReabre(state.emAtendimento.id))
  },
  async descartar ({ commit }, dados) {
    const retorno = await pedido.descartar(state.emAtendimento.id, dados)
    return retorno
  },
  async descartarTelemarketing ({ commit }, dados) {
    const retorno = await pedido.descartarTelemarketing(state.emAtendimento.id, dados)
    return retorno
  },
  async finalizar ({ commit }) {
    const retorno = await pedido.finalizar(state.emAtendimento.id)
    return retorno
  },
  async getFuturos ({ commit }, valor) {
    let dados = {}
    if (valor !== undefined) {
      dados.valor = valor
    }
    const retorno = await pedido.futuros(state.emAtendimento.id, dados)
    return retorno
  },
  async reagendar ({ commit }, dados) {
    const retorno = await pedido.reagendar(state.emAtendimento.id, dados)
    return retorno
  },
  async agendarFechamento ({ commit }, dados) {
    const retorno = await pedido.agendarFechamento(state.emAtendimento.id, dados)
    return retorno
  },
  async setPedidoEmAtendimento ({ state }) {
    const retorno = await pedido.setPedidoAtendimento(state.emAtendimento.id)
    return retorno
  },
  async getPedidoEmAtendimento ({ state }) {
    const retorno = await pedido.getPedidoAtendimento(state.emAtendimento.id)
    return retorno
  },
  async removePedidoEmAtendimento ({ state }) {
    const retorno = await pedido.inativaPedidoAtendimento(state.emAtendimento.id)
    return retorno
  },
  mostraAgendaAutomatico ({ state, commit }, payload) {
    commit('MOSTRAAGENDAAUTOMATICO', payload)
  },
  mostraImprimeContratos ({ state, commit }, payload) {
    commit('MOSTRAIMPRIMECONTRATOS', payload)
  },
  mostraImprimeRelacao ({ state, commit }, payload) {
    commit('MOSTRAIMPRIMERELACAO', payload)
  },
  mostraLancarContratos ({ state, commit }, payload) {
    commit('MOSTRALANCARCONTRATOS', payload)
  },
  async getHistAtendimentos ({ state, commit }, payload) {
    if (!state.fimAtendimentos || payload.page === 1) {
      const retorno = await pedido.getHistAtendimentos(payload)
      if (payload.page > 1) commit('SETHISTATENDIMENTOSPUSH', retorno.instancia.list)
      else {
        state.fimAtendimentos = false
        commit('SETHISTATENDIMENTOS', retorno.instancia.list)
      }
    }
  },
  storageRota  ({ commit }, payload) { // armazena a rota de pedido vindo da index
    commit('STORAGEROTA', payload)
  },
  controlaModalCliente ({ commit }, payload) {
    commit('CONTROLAMODALCLIENTE', payload)
  },
  setAtendimentoTele ({ commit }, payload) {
    commit('SETATENDIMENTOTELE', payload)
  },
  mostraModalAtendimentoTele ({ commit }, payload) {
    commit('MOSTRAMODALATENDIMENTOTELE', payload)
  },
  async mudaVendaDigital ({ commit }, payload) {
    let result = await pedido.mudaVendaDigital(payload)
    commit('MUDAVENDADIGITAL', payload.venda_digital)
    return result
  },
  async validarProposta ({ commit }, payload) {
    let result = await pedido.validaProposta(payload)
    commit('VALIDAPROPOSTA', result)
    return result
  },
  async desvalidarProposta ({ commit }, payload) {
    let result = await pedido.desvalidaProposta(payload)
    commit('VALIDAPROPOSTA', result)
    return result
  },
  validaDataValidacao ({ state, commit }, payload) {
    state.validado = false
    if (state.emAtendimento.data_validacao) {
      let dataRetro = new Date()
      dataRetro.setDate(dataRetro.getDate() - 7)
      let dataVal = new Date(state.emAtendimento.data_validacao)
      if (dataVal >= dataRetro) state.validado = true
    }
    commit('SETVALIDADATAVALIDACAO', state.validado)
  },
  salvaAntesValidar ({ commit }, payload) {
    commit('SALVAANTESVALIDAR', payload)
  },
  ctrlDesvalidarProposta ({commit}, payload) {
    commit('CTRLDESVALIDARPROPOSTA', payload)
  },
  async atualizaBeneficioContratos ({ commit }, payload = requiredParam('Pedido obrigatório para consultar a api')) {
    let result = await pedido.atualizaBeneficioContratos(payload)
    return result.instancia
  },
  async filaAtualizaContratos ({ commit }, payload = requiredParam('Pedido obrigatório para enfileirar atualiza contratos')) {
    let result = await pedido.filaAtualizaContratos(payload)
    return result.instancia
  },
  async filaAtualizaContratosIgnorarData ({ commit }, payload = requiredParam('Pedido obrigatório para enfileirar atualiza contratos')) {
    let result = await pedido.filaAtualizaContratosIgnorarData(payload)
    return result.instancia
  },
  async limpaCachePedidoAndOrcamento ({ commit }, payload = requiredParam('Pedido obrigatório para limpar cache')) {
    await pedido.limpaCachePedidoAndOrcamento(payload)
  },
  terminouChamadaAPI ({ commit }) {
    commit('STATUSCHAMADAAPI', true)
  },
  resetaStatusChamadaAPI ({ commit }) {
    commit('STATUSCHAMADAAPI', false)
  },
  setPedidoRecalculando ({ commit }, payload) {
    commit('SETPEDIDORECALCULANDO', payload)
  },
  actionTriggerGetPedidos ({ commit }) {
    commit('SETTRIGGERGETPEDIDOS')
  },
  actionTriggerGetMotivos ({ commit }) {
    commit('SETTRIGGERGETMOTIVOS')
  },
  corrigeResumo ({ commit, state }, payload) {
    let itens = state.emAtendimento.itens.consignado_inss
    if (!payload.possibilidade_cartao && !payload.possibilidade_cartao.id) {
      if (itens && payload.margem_consig < 0) {
        let indice = itens.beneficios.findIndex(item => {
          return item.beneficio === payload.beneficio
        })
        if (indice > -1) {
          if (itens.beneficios[indice]) {
            let itemRemove = itens.beneficios[indice]
            itens.comissao = itens.comissao - itemRemove.comissao
            itens.total = itens.total - itemRemove.total
            delete itens.beneficios[indice]
          }
        }
        commit('CORRIGERESUMO', itens)
        commit('NAOATRATIVO', (itens.comissao === 0 && itens.total === 0))
      } else {
        commit('NAOATRATIVO', true)
      }
    }
  },
  setRecalculando ({ commit }, payload) {
    commit('TOGGLERESUMO', !payload)
    commit('SETRECALCULANDO', payload)
  },
  async verificaFila ({ state }, dados) {
    return pedido.verificaFila(dados)
  },
  toggleResumo ({ commit, dispatch }, payload) {
    commit('TOGGLERESUMO', payload)
  },
  async hangfireStatistics ({ state }, dados) {
    return pedido.hangfireStatistics(dados)
  },
  foiCalculado ({ commit }, payload) {
    commit('FOICALCULADO', payload)
  },
  async atualizaTelefones ({ commit }, payload) {
    let entidade = await consulta.higienizacaoTelefonesAssertivaAsync(payload)
    let instancia = entidade.instancia
    commit('SETATENDIMENTOENTIDADEHIGIENIZADA', instancia)
    return instancia
  },
  setSiape ({ commit }, payload) {
    commit('SETSIAPE', payload)
  },
  setCadastral ({ commit }, payload) {
    commit('SETCADASTRAL', payload)
  },
  setFGTS ({ commit }, payload) {
    commit('SETFGTS', payload)
  },
  controlaBloqueiaAcoes ({ commit }, payload) {
    commit('CONTROLABLOQUEIAACOES', payload)
  },
  async deletaCache ({ commit }, payload) {
    return pedido.deletaCache(payload)
  },
  setDataRelacionados ({commit}) {
    commit('SETDATARELACIONADOS', true)
  },
  async atualizaNomeFGTS ({commit}, payload) {
    let nome = await pedido.atualizaNomeFGTS(payload)
    commit('ATUALIZANOMEFGTS', nome)
  },
  async buscaTelefonesOffline ({commit}, payload) {
    let retorno = await pedido.buscaTelefonesOffline(payload)
    commit('SETTELEFONES', retorno.telefones)
    return retorno
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/index.js